import { hasRoleSlug } from '@utils/user';
import { useMemo } from 'react';

import { useCurrentUserContextRoles } from '@/hooks/usePermissions';

const DEVELOPER_SETTINGS_ROLE_SLUGS = ['organization-admin', 'system-admin'] as const;

/**
 * Whether Settings shows the Developer tab (webhooks, API keys, service
 * accounts, developer mode): Organization Admins of the selected organization
 * and system admins. There is no separate developer permission, so the
 * organization admin role stands in for it.
 *
 * UI gate only: each section still checks its own permission (webhooks its
 * flag and permission map, API keys the orgs the user administers) and the
 * server enforces every request.
 */
export const useShouldShowDeveloperSettings = (): { shouldShow: boolean; isLoading: boolean } => {
  const { roles, isLoading } = useCurrentUserContextRoles();

  const shouldShow = useMemo(
    () => DEVELOPER_SETTINGS_ROLE_SLUGS.some(slug => hasRoleSlug(roles, slug)),
    [roles],
  );

  return { shouldShow, isLoading };
};
